export class User {
  nome: string;
  password: string;
  token: string;
}